import { map } from 'lodash/fp';
import { PRODUCT_TYPE } from '@ahmdigital/constants';
import { useCallback } from 'react';
import { useFormikContext } from 'formik';

import { ContentWrapper, CoverContainer } from './styles';
import { ModalComponentProps } from '../../../../../../components/embedded-widget/types';
import { StyledHeading, StyledJourneyButton } from '../styles';
import { TYPE_LABEL } from '../../../../../../ahm-constants/ui';

const CoverSelector = ({ setIsModalOpen }: ModalComponentProps) => {
  const { setFieldValue } = useFormikContext();

  const COVER_LABEL: Record<string, string> = {
    [PRODUCT_TYPE.HOSPITAL]: TYPE_LABEL.HOSPITAL,
    [PRODUCT_TYPE.EXTRAS]: TYPE_LABEL.EXTRAS,
    [PRODUCT_TYPE.PACKAGE]: TYPE_LABEL.PACKAGE,
  };
  const COVER_OPTIONS = [PRODUCT_TYPE.HOSPITAL, PRODUCT_TYPE.EXTRAS, PRODUCT_TYPE.PACKAGE];

  const setCoverHandler = useCallback(
    (cover: (typeof COVER_OPTIONS)[number]) => {
      setFieldValue('cover', cover);
      setFieldValue('productType', cover);
      setIsModalOpen(false);
    },
    [setFieldValue, setIsModalOpen],
  );

  return (
    <ContentWrapper>
      <StyledHeading looksLike="h5">Please select what type of cover.</StyledHeading>
      <CoverContainer>
        {map(
          (cover: (typeof COVER_OPTIONS)[number]) => (
            <StyledJourneyButton key={cover} onClick={() => setCoverHandler(cover)}>
              {COVER_LABEL[cover]}
            </StyledJourneyButton>
          ),
          COVER_OPTIONS,
        )}
      </CoverContainer>
    </ContentWrapper>
  );
};

export default CoverSelector;
